<template>
  <div class="footer">
    <div class="button-container" :class="{ 'single-button': !hasFacialRecognition }">
      <b-button class="icon-box" :to="{ name: routeScanName }">
        <img src="@/assets/images/icon/qr-code-scan.png" alt="">
      </b-button>
      <b-button v-if="hasFacialRecognition" class="icon-box2" :to="{ name: routeFacialName }">
        <img src="@/assets/images/icon/facial-recog.png" alt="" width="34px">
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { STORAGE_PAGE_SCAN, STORAGE_PAGE_FACIAL } from '@/modules/storage/routes'

export default {
  name: 'index-footer',
  data: function () {
    return {
      routeScanName: STORAGE_PAGE_SCAN,
      routeFacialName: STORAGE_PAGE_FACIAL
    }
  },
  computed: {
    ...mapState('settingsRSVP', {
      settingRSVP: function (state) { return state.settingRSVP }
    }),
    hasFacialRecognition: function () {
      return this.settingRSVP && this.settingRSVP.enable_facial_recognition
    }
  }
}
</script>

<style scoped>
.footer {
  z-index: 2;
  background-color: #292f41;
  position: fixed;
}

.icon-box {
  color: #ffffff;
  font-size: 25px;
  background-color: #564AB1;
  width: 64px;
  height: 64px;
  border-radius: 100%;
  position: absolute;
  display: grid;
  place-items: center;
  border: 0;
  top: -50%;
  left: 46%;
  transform: translate(-50%);
}

/* Quando só tem um botão, centraliza */
.single-button .icon-box {
  left: 50%;
}

.icon-box2 {
  color: #ffffff;
  font-size: 25px;
  background-color: #564AB1;
  width: 64px;
  height: 64px;
  border-radius: 100%;
  position: absolute;
  display: grid;
  place-items: center;
  border: 0;
  top: -50%;
  left: 54%;
  transform: translate(-50%);
}

.icon-box2 img {
  filter: brightness(0) invert(1);
}

@media (max-width: 767px) {
  .button-container {
    padding: 8px;
  }

  .icon-box {
    width: 48px;
    height: 48px;
    font-size: 20px;
  }

  .icon-box2 {
    width: 48px;
    height: 48px;
    font-size: 20px;
  }

  .icon-box2 img {
    width: 24px;
  }

  .icon-box img {
    width: 24px;
  }
}
</style>
